// exclude-from-index
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { StyledLink } from './Link.styles';

class Link extends Component {
  render() {
    const { children } = this.props;

    return <StyledLink {...this.props}>{children}</StyledLink>;
  }
}

Link.propTypes = {
  /** Copy inside the link tag */
  children: PropTypes.string.isRequired,
  /** Href used for SEO value */
  href: PropTypes.string,
  /** Href used for SEO value */
  onClick: PropTypes.func
};

Link.defaultProps = {
  onClick: null,
  href: undefined
};

export default Link;
